import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { PrintableRecord } from './PrintableRecord'
import { Button } from '@/components/ui/button'
import { usePatient } from '../hooks/usePatient'
import { PrinterIcon } from 'lucide-react'

interface PrintPatientRecordDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  patientId: string
}

export const PrintPatientRecordDialog: React.FC<PrintPatientRecordDialogProps> = ({ 
  open, 
  onOpenChange, 
  patientId 
}) => {
  const { data: patient } = usePatient(patientId)

  const handlePrint = () => {
    window.print()
  }

  if (!patient) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[800px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Patient Record</DialogTitle>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={handlePrint}
            className="ml-auto"
          >
            <PrinterIcon className="mr-2 h-4 w-4" /> Print
          </Button>
        </DialogHeader>
        <PrintableRecord 
          patient={patient} 
          sections={['demographics', 'medical', 'insurance']} 
        />
      </DialogContent>
    </Dialog>
  )
}
